<template>
    <div>
      <ion-grid class="page-center-logo">
        <ion-row>
          <ion-col>
            <img src="/assets/images/logo/rapid.png" alt />
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </template>
  
  <script>
  import { AuthenticationService } from "../service/account/authenticator.service";
  import { LocalStorage } from "../data/localstorage";
  // import { AppUtils } from "../util/app-utils";
  // import { logger } from "../logger";
  
  // import { Plugins, StatusBarStyle } from '@capacitor/core';
  // const { StatusBar, StatusBarBackgroundColorOptions } = Plugins;
  
  export default {
    name: "appLaunch",
    computed: {
      loggedIn: function() {
        return this.$store.state.user.isAuthenticated;
      },
      userRole: function() {
        return this.$store.state.user.userRole;
      }
    },
    data() {
      return {
        landpage: this.userRole ? this.userRole : "LOGIN"
      };
    },
    created() {
      // StatusBar.setBackgroundColor({ color: '#21B24B'});
      // this.landpage = 'LOGIN'
    },
    mounted() {
      setTimeout(() => {
        const user = new LocalStorage().user;
        if (user) {
          // if (this.$router.currentRoute.name == "appLaunch") {
          if (this.$route.name == "appLaunch") {
            this.userLandingPage(user);
          }
        } else {
          window.localStorage.clear();
          this.$router.push("/login");
        }
      }, 5000);
    },
    methods: {
      async userLandingPage(user) {
        try {
          const userPermissions = await new AuthenticationService().permissionsOfUser(
            user
          );
          
          const isCustomer = userPermissions.find(
            userPermission => userPermission.id == "10|C"
          );
          const isAdmin = userPermissions.find(
            userPermission => userPermission.id == "10|T"
          );
          const isCorpUser = userPermissions.find(
            userPermission => userPermission.id == "130|C"
          )
          if (isCustomer) {
            // this.$router.push("/customer/reservation");
            this.$router.push("/customer/reservation");
          } else if (isAdmin) {
            // if (
            //   navigator.platform.indexOf("iPhone") != -1 ||
            //   navigator.platform.indexOf("iPod") != -1 ||
            //   navigator.platform.indexOf("iPad") != -1 ||
            //   navigator.platform.indexOf("Android") != -1
            // ) {
            //   this.$router.push("/common/gotoweblogin");
            // } else {
            //   this.$router.push("/admin/reservations");
            // }
            this.$router.push("/admin/adminDashboard");
          } else if(isCorpUser) {
            this.$router.push("/corporate/cpoAdminDashboard");
          } 
          else {
            this.$router.push("/common/helpdesk");
          }
        } catch (error) {
          
          // logger.info(error);
          window.localStorage.clear();
          this.$router.push("/login");
        }
      }
    }
  };
  </script>
  
  <style scoped>
    .page-center-logo {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  @media screen and (min-width: 720px) {
    .page-center-logo {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  </style>
  